var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-header" }, [
    _c("div", { staticClass: "app-header__inner" }, [
      _c(
        "div",
        { staticClass: "app-header__brand", on: { click: _vm.homepay } },
        [
          _c("span", { staticClass: "app-header__mark" }, [_vm._v("医")]),
          _c("span", { staticClass: "app-header__name" }, [
            _vm._v(_vm._s(_vm.configdata.projectname)),
          ]),
        ]
      ),
      _c("div", { staticClass: "app-header__service" }, [
        _c("i", { staticClass: "el-icon-service app-header__icon" }),
        _c("span", { staticClass: "app-header__phone" }, [
          _vm._v(_vm._s(_vm.servicePhone)),
        ]),
        _c("span", { staticClass: "app-header__time" }, [
          _vm._v("工作日 9:00-18:00"),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }